var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Icon from './Icon';
import * as _ from "lodash";
import * as React from 'react';
import styled from 'styled-components';
import { fadeColor, getColor } from '../helpers/ColorHelpers';
var StarContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    cursor: ", ";\n    pointer-events: ", ";\n    transition: all 0.2s ease-out;\n    transform-origin: center center;\n    ", "\n"], ["\n    display: inline-block;\n    cursor: ", ";\n    pointer-events: ", ";\n    transition: all 0.2s ease-out;\n    transform-origin: center center;\n    ", "\n"])), function (p) { return p.selected === true ? "default" : "pointer"; }, function (p) { return p.selected === true ? "none" : "all"; }, function (p) {
    var _a, _b, _c, _d;
    return p.filledOut && "\n    svg{\n        transition: all 0.2s ease-out;\n        stroke:".concat((_a = p.filledColor) !== null && _a !== void 0 ? _a : p.theme.color, " !important;\n        fill:  ").concat(p.isEmptyStar ? "transparent" : getColor(p, (_b = p.filledColor) !== null && _b !== void 0 ? _b : p.theme.color), " !important;\n    }\n    &:hover{\n        transform: scale(1.2);\n        svg{\n            stroke:").concat((_c = p.filledColor) !== null && _c !== void 0 ? _c : p.theme.color, " !important;\n            fill:  ").concat(fadeColor(p, (_d = p.filledColor) !== null && _d !== void 0 ? _d : p.theme.color, 40), " !important;\n        }\n    }\n    ");
});
var RatingSelect = /** @class */ (function (_super) {
    __extends(RatingSelect, _super);
    function RatingSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.setSelected = function (selected) { return function () {
            selected += 1;
            _this.setState({ selected: selected });
            _this.props.vote && _this.props.vote(selected);
        }; };
        _this.state = {
            selected: 0
        };
        return _this;
    }
    RatingSelect.prototype.render = function () {
        var _this = this;
        var _a;
        var maxStars = (_a = this.props.maxStars) !== null && _a !== void 0 ? _a : 5;
        var sel = this.props.value !== undefined ? this.props.value : this.state.selected;
        return (React.createElement(React.Fragment, null, _.times(maxStars, function (i) {
            var _a, _b;
            if (sel >= i + 1)
                return React.createElement(StarContainer, { key: "a-" + i, onClick: _this.setSelected(i), isEmptyStar: false, filledColor: _this.props.filledColor, selected: (i + 1) === sel, filledOut: _this.props.filledOut },
                    React.createElement(Icon, { name: "star full", size: (_a = _this.props.size) !== null && _a !== void 0 ? _a : 24, filledOut: _this.props.filledOut, filledColor: _this.props.filledColor }));
            else
                return React.createElement(StarContainer, { key: "b-" + i, onClick: _this.setSelected(i), isEmptyStar: true, filledColor: _this.props.filledColor, filledOut: _this.props.filledOut },
                    React.createElement(Icon, { name: "star empty", size: (_b = _this.props.size) !== null && _b !== void 0 ? _b : 24, filledOut: _this.props.filledOut, filledColor: _this.props.filledColor }));
        })));
    };
    return RatingSelect;
}(React.PureComponent));
export default RatingSelect;
var templateObject_1;
//# sourceMappingURL=RatingSelect.js.map